import { MultiSelect } from "primereact/multiselect";
import { IDropdownData, IMultipleSelect } from "../models/ICommon";
import { useEffect, useState } from "react";

function MultipleSelect({
  values,
  optionList = [],
  onChange,
  name,
  label,
  optionLabel,
  isMandatory,
  disabled,
  placeholder
}: IMultipleSelect) {
  const [selectedItemObjects, setSelectedItemObjects] = useState<
    IDropdownData[]
  >([]);

  useEffect(() => {
    if (optionList && optionList.length > 0 && values)
      setSelectedItemObjects(
        optionList.filter((item: IDropdownData) => values.includes(item.id))
      );
  }, [values, optionList]);

  const onMultiSelect = (data: any) => {
    let selectedItems: number[] = [];

    if (data.length > -1) selectedItems = data.map((c: any) => c.id);

    const event: any = {
      target: {
        name: name,
        value: selectedItems,
      },
    };

    onChange(event);
  }


  return (
    <>
      <label>
        {label}
        {isMandatory && <i className="label-asterisk">*</i>}
      </label>
      <MultiSelect
        className="col-md-12"
        value={selectedItemObjects}
        options={optionList}
        onChange={(e: any) => onMultiSelect(e.value)}
        filter
        resetFilterOnHide
        optionLabel={optionLabel ? optionLabel : "name"}
        //display="chip"
        disabled={disabled}
        placeholder={placeholder}
        onBlur={() => {
          document.querySelectorAll(".p-inputwrapper-focus").forEach((el) => {
            el.classList.remove("p-inputwrapper-focus");
          });
        }}              
        onWheel={(e) => {
          setTimeout(() => {
            if (!e.currentTarget) return;
            const target = e.currentTarget.closest(".p-inputwrapper-focus");
            if (target) {
              target.classList.remove("p-inputwrapper-focus");
              console.log("Removed focus after timeout");
            }
          }, 10);
        }}                           
      />
    </>
  );
}

export default MultipleSelect;
